define("media/components/media/asset-filter", ["exports", "@ember/component", "@ember/object", "@ember/object/computed", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "later/lib/filter-by-fields", "later/utils/constants", "@ember/template-factory"], function (_exports, _component, _object, _computed, _utils, _component2, _tracking, _filterByFields, _constants, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"later/lib/filter-by-fields",0,"later/utils/constants",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="cMF--filter">
    {{!  Header }}
    <div class="cMF--filter__header">
      {{#if @isBeingFiltered}}
        <Shared::Ui::Button
          @class="qa--mediaLib_clearFilter_btn"
          @onClick={{@clearAllFilters}}
          @text={{t "media_library.filter.clear"}}
        />
      {{else}}
        <div class="cMF--filter__headerTitle">
          {{svg-jar "filter" class="o--icon u--m__r__xs"}}
          {{html-safe (t "media_library.filter.title")}}
        </div>
      {{/if}}
    </div>
    <ul class="cMF--filter__content" {{perfect-scroll}}>
      {{!  Media Notes }}
      <li class="cMF--filter__category">
        <h5 class="cMF--filter__title">
          {{t "media_library.filter.media_notes"}}
        </h5>
        <div class="o--formWrapper">
          <div class="o--inputAction--light u--p__r__xs">
            {{svg-jar "search" class="o--icon o--inputAction__icon--left"}}
            <Input
              @enter={{@searchMediaNotes}}
              @type="search"
              @value={{@searchString}}
              class="o--inputAction__input u--p__r__md qa--mediaLib_notes_input"
              id="mediaNoteSearch"
              placeholder={{t "media_library.filter.search_placeholder"}}
              {{autofocus}}
            />
            {{#if @hasSearchTerms}}
              <span {{on "click" @clearMediaSearch}}>
                {{svg-jar "close" class="o--icon o--inputAction__icon--right u--fadeIn--right"}}
              </span>
            {{/if}}
          </div>
        </div>
      </li>
      {{!  Media Usage }}
      <li class="cMF--filter__category">
        <h5 class="cMF--filter__title">
          {{t "media_library.filter.media_usage"}}
        </h5>
        <Shared::Media::Filter::FilterMediaUsage @setUsedUnused={{@setUsedUnused}} @usedUnused={{@usedUnused}} />
        {{#if this.showSocialProfileFilter}}
          <Shared::Media::Filter::FilterProfile
            @group={{@group}}
            @selectedSocialProfileIds={{@querySocialProfileIds}}
            @toggleSocialProfile={{this.toggleSocialProfile}}
          />
        {{/if}}
      </li>
      {{!  Media Type }}
      <li class="cMF--filter__category">
        <h5 class="cMF--filter__title">
          {{t "media_library.filter.media_type"}}
        </h5>
        {{!  Filter by  Media Type }}
        <Shared::Media::Filter::FilterMediaType
          @mediaTypeFilter={{@mediaTypeFilter}}
          @setMediaTypeFilter={{@setMediaTypeFilter}}
        />
      </li>
      {{!  Time Uploaded }}
      <li class="cMF--filter__category">
        <h5 class="cMF--filter__title">
          {{t "media_library.filter.time_uploaded"}}
        </h5>
        <div class="o--formWrapper">
          <Shared::Media::Filter::FilterDateRange
            @selectedDateRange={{@setDateFilter}}
            @updateDateRange={{@updateDateFilter}}
          />
        </div>
      </li>
      {{!  Label List }}
      {{#if this.sortedSystemLabels.length}}
        {{!  System Labels }}
        <li class="cMF--filter__category">
          <h5 class="cMF--filter__title">
            {{t "media_library.filter.system_labels"}}
            <span>
              {{svg-jar "help" class="o--icon o--icon--light"}}
              <EmberTooltip @delay={{330}} @side="top">
                {{t "media_library.filter.system_labels_tooltip"}}
              </EmberTooltip>
            </span>
          </h5>
          {{#each this.sortedToggledSystemLabels as |systemLabel|}}
            <div class="cLB--filter__item">
              <div
                class="cLB--label cLB--label--system u--ellipsis
                  {{if systemLabel.selected 'is--active'}}
                  qa--systemLabel__{{systemLabel.qaClassName}}"
                {{on "click" (fn this.toggleLabel systemLabel.id)}}
              >
                {{#if systemLabel.selected}}
                  {{svg-jar "check" class="o--icon o--icon--success"}}
                {{/if}}
                <span>
                  {{systemLabel.canonicalTagName}}
                </span>
                <span class="cLB--label__counter">
                  {{systemLabel.taggedCount}}
                </span>
              </div>
            </div>
          {{/each}}
        </li>
      {{/if}}
      {{!  User Labels }}
      <li class="cMF--filter__category">
        <h5 class="cMF--filter__title">
          {{t "media_library.filter.my_labels"}}
          {{! Label Dropdown }}
          <Shared::Ui::Button
            @class="u--text--sm u--text--uppercase u--float--right qa--mediaLib_manageLabel_link"
            @onClick={{this.openManageLabelsModal}}
            @text={{t "media_library.filter.manage"}}
            @variant="actionLink"
          />
        </h5>
        <div class="o--formWrapper">
          <div class="o--inputAction u--p__r__xs">
            {{svg-jar "search" class="o--icon o--inputAction__icon--left"}}
            <Input
              @type="search"
              @value={{this.labelSearchString}}
              class="o--inputAction__input u--p__r__md qa--mediaLib_myLabel_inputbx"
              placeholder={{t "media_library.filter.search_labels"}}
            />
            {{#if this.isSearchingLabels}}
              <span {{on "click" this.clearLabelSearch}}>
                {{svg-jar "close" class="o--icon o--inputAction__icon--right u--fadeIn--right"}}
              </span>
            {{/if}}
          </div>
        </div>
        {{!  Label List: Note: Limit Labels to 5}}
        {{#each this.sortedToggledUserLabels as |userLabel|}}
          <div class="cLB--filter__item">
            <div
              class="cLB--label u--ellipsis qa--mediaLib_labelFilter {{if userLabel.selected 'is--active'}}"
              {{on "click" (fn this.toggleLabel userLabel.id)}}
            >
              {{#if userLabel.selected}}
                {{svg-jar "check" class="o--icon o--icon--success"}}
              {{/if}}
              <span>
                {{userLabel.canonicalTagName}}
              </span>
              <span class="cLB--label__counter">
                {{userLabel.taggedCount}}
              </span>
            </div>
          </div>
        {{/each}}
        {{!  Show More }}
        {{#if this.showLoadMoreLabels}}
          <a class="o--btn--sm o--btn--block u--text--center u--m__tb__xs" {{on "click" this.toggleAllLabels}}>
            {{#if this.showAllLabels}}
              {{t "media_library.filter.show_less"}}
            {{else}}
              {{t "media_library.filter.show_all"}}{{svg-jar "caret-down" class="o--icon--sm"}}
            {{/if}}
          </a>
        {{/if}}
      </li>
    </ul>
  </div>
  {{#if this.showManageLabelsModal}}
    <Media::ManageLabels
      @addNewLabel={{@addNewLabel}}
      @closeManageLabelsModal={{this.closeManageLabelsModal}}
      @labels={{this.nonSystemLabels}}
      @showManageLabelsModal={{this.showManageLabelsModal}}
    />
  {{/if}}
  */
  {
    "id": "yXY9SqoF",
    "block": "[[[10,0],[14,0,\"cMF--filter\"],[12],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"cMF--filter__header\"],[12],[1,\"\\n\"],[41,[30,1],[[[1,\"      \"],[8,[39,1],null,[[\"@class\",\"@onClick\",\"@text\"],[\"qa--mediaLib_clearFilter_btn\",[30,2],[28,[37,2],[\"media_library.filter.clear\"],null]]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,0,\"cMF--filter__headerTitle\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"filter\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n        \"],[1,[28,[35,4],[[28,[37,2],[\"media_library.filter.title\"],null]],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n  \"],[11,\"ul\"],[24,0,\"cMF--filter__content\"],[4,[38,5],null,null],[12],[1,\"\\n\"],[1,\"    \"],[10,\"li\"],[14,0,\"cMF--filter__category\"],[12],[1,\"\\n      \"],[10,\"h5\"],[14,0,\"cMF--filter__title\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"media_library.filter.media_notes\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"o--inputAction--light u--p__r__xs\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"search\"],[[\"class\"],[\"o--icon o--inputAction__icon--left\"]]]],[1,\"\\n          \"],[8,[39,6],[[24,0,\"o--inputAction__input u--p__r__md qa--mediaLib_notes_input\"],[24,1,\"mediaNoteSearch\"],[16,\"placeholder\",[28,[37,2],[\"media_library.filter.search_placeholder\"],null]],[4,[38,7],null,null]],[[\"@enter\",\"@type\",\"@value\"],[[30,3],\"search\",[30,4]]],null],[1,\"\\n\"],[41,[30,5],[[[1,\"            \"],[11,1],[4,[38,8],[\"click\",[30,6]],null],[12],[1,\"\\n              \"],[1,[28,[35,3],[\"close\"],[[\"class\"],[\"o--icon o--inputAction__icon--right u--fadeIn--right\"]]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[1,\"    \"],[10,\"li\"],[14,0,\"cMF--filter__category\"],[12],[1,\"\\n      \"],[10,\"h5\"],[14,0,\"cMF--filter__title\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"media_library.filter.media_usage\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,9],null,[[\"@setUsedUnused\",\"@usedUnused\"],[[30,7],[30,8]]],null],[1,\"\\n\"],[41,[30,0,[\"showSocialProfileFilter\"]],[[[1,\"        \"],[8,[39,10],null,[[\"@group\",\"@selectedSocialProfileIds\",\"@toggleSocialProfile\"],[[30,9],[30,10],[30,0,[\"toggleSocialProfile\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"],[1,\"    \"],[10,\"li\"],[14,0,\"cMF--filter__category\"],[12],[1,\"\\n      \"],[10,\"h5\"],[14,0,\"cMF--filter__title\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"media_library.filter.media_type\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"],[1,\"      \"],[8,[39,11],null,[[\"@mediaTypeFilter\",\"@setMediaTypeFilter\"],[[30,11],[30,12]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"],[1,\"    \"],[10,\"li\"],[14,0,\"cMF--filter__category\"],[12],[1,\"\\n      \"],[10,\"h5\"],[14,0,\"cMF--filter__title\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"media_library.filter.time_uploaded\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n        \"],[8,[39,12],null,[[\"@selectedDateRange\",\"@updateDateRange\"],[[30,13],[30,14]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,0,[\"sortedSystemLabels\",\"length\"]],[[[1,\"      \"],[10,\"li\"],[14,0,\"cMF--filter__category\"],[12],[1,\"\\n        \"],[10,\"h5\"],[14,0,\"cMF--filter__title\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"media_library.filter.system_labels\"],null]],[1,\"\\n          \"],[10,1],[12],[1,\"\\n            \"],[1,[28,[35,3],[\"help\"],[[\"class\"],[\"o--icon o--icon--light\"]]]],[1,\"\\n            \"],[8,[39,13],null,[[\"@delay\",\"@side\"],[330,\"top\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,2],[\"media_library.filter.system_labels_tooltip\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"],[42,[28,[37,15],[[28,[37,15],[[30,0,[\"sortedToggledSystemLabels\"]]],null]],null],null,[[[1,\"          \"],[10,0],[14,0,\"cLB--filter__item\"],[12],[1,\"\\n            \"],[11,0],[16,0,[29,[\"cLB--label cLB--label--system u--ellipsis\\n                \",[52,[30,15,[\"selected\"]],\"is--active\"],\"\\n                qa--systemLabel__\",[30,15,[\"qaClassName\"]]]]],[4,[38,8],[\"click\",[28,[37,16],[[30,0,[\"toggleLabel\"]],[30,15,[\"id\"]]],null]],null],[12],[1,\"\\n\"],[41,[30,15,[\"selected\"]],[[[1,\"                \"],[1,[28,[35,3],[\"check\"],[[\"class\"],[\"o--icon o--icon--success\"]]]],[1,\"\\n\"]],[]],null],[1,\"              \"],[10,1],[12],[1,\"\\n                \"],[1,[30,15,[\"canonicalTagName\"]]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,1],[14,0,\"cLB--label__counter\"],[12],[1,\"\\n                \"],[1,[30,15,[\"taggedCount\"]]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[15]],null],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[10,\"li\"],[14,0,\"cMF--filter__category\"],[12],[1,\"\\n      \"],[10,\"h5\"],[14,0,\"cMF--filter__title\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"media_library.filter.my_labels\"],null]],[1,\"\\n\"],[1,\"        \"],[8,[39,1],null,[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"u--text--sm u--text--uppercase u--float--right qa--mediaLib_manageLabel_link\",[30,0,[\"openManageLabelsModal\"]],[28,[37,2],[\"media_library.filter.manage\"],null],\"actionLink\"]],null],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"o--inputAction u--p__r__xs\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"search\"],[[\"class\"],[\"o--icon o--inputAction__icon--left\"]]]],[1,\"\\n          \"],[8,[39,6],[[24,0,\"o--inputAction__input u--p__r__md qa--mediaLib_myLabel_inputbx\"],[16,\"placeholder\",[28,[37,2],[\"media_library.filter.search_labels\"],null]]],[[\"@type\",\"@value\"],[\"search\",[30,0,[\"labelSearchString\"]]]],null],[1,\"\\n\"],[41,[30,0,[\"isSearchingLabels\"]],[[[1,\"            \"],[11,1],[4,[38,8],[\"click\",[30,0,[\"clearLabelSearch\"]]],null],[12],[1,\"\\n              \"],[1,[28,[35,3],[\"close\"],[[\"class\"],[\"o--icon o--inputAction__icon--right u--fadeIn--right\"]]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[42,[28,[37,15],[[28,[37,15],[[30,0,[\"sortedToggledUserLabels\"]]],null]],null],null,[[[1,\"        \"],[10,0],[14,0,\"cLB--filter__item\"],[12],[1,\"\\n          \"],[11,0],[16,0,[29,[\"cLB--label u--ellipsis qa--mediaLib_labelFilter \",[52,[30,16,[\"selected\"]],\"is--active\"]]]],[4,[38,8],[\"click\",[28,[37,16],[[30,0,[\"toggleLabel\"]],[30,16,[\"id\"]]],null]],null],[12],[1,\"\\n\"],[41,[30,16,[\"selected\"]],[[[1,\"              \"],[1,[28,[35,3],[\"check\"],[[\"class\"],[\"o--icon o--icon--success\"]]]],[1,\"\\n\"]],[]],null],[1,\"            \"],[10,1],[12],[1,\"\\n              \"],[1,[30,16,[\"canonicalTagName\"]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,1],[14,0,\"cLB--label__counter\"],[12],[1,\"\\n              \"],[1,[30,16,[\"taggedCount\"]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[16]],null],[41,[30,0,[\"showLoadMoreLabels\"]],[[[1,\"        \"],[11,3],[24,0,\"o--btn--sm o--btn--block u--text--center u--m__tb__xs\"],[4,[38,8],[\"click\",[30,0,[\"toggleAllLabels\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"showAllLabels\"]],[[[1,\"            \"],[1,[28,[35,2],[\"media_library.filter.show_less\"],null]],[1,\"\\n\"]],[]],[[[1,\"            \"],[1,[28,[35,2],[\"media_library.filter.show_all\"],null]],[1,[28,[35,3],[\"caret-down\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n\"]],[]]],[1,\"        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[41,[30,0,[\"showManageLabelsModal\"]],[[[1,\"  \"],[8,[39,17],null,[[\"@addNewLabel\",\"@closeManageLabelsModal\",\"@labels\",\"@showManageLabelsModal\"],[[30,17],[30,0,[\"closeManageLabelsModal\"]],[30,0,[\"nonSystemLabels\"]],[30,0,[\"showManageLabelsModal\"]]]],null],[1,\"\\n\"]],[]],null]],[\"@isBeingFiltered\",\"@clearAllFilters\",\"@searchMediaNotes\",\"@searchString\",\"@hasSearchTerms\",\"@clearMediaSearch\",\"@setUsedUnused\",\"@usedUnused\",\"@group\",\"@querySocialProfileIds\",\"@mediaTypeFilter\",\"@setMediaTypeFilter\",\"@setDateFilter\",\"@updateDateFilter\",\"systemLabel\",\"userLabel\",\"@addNewLabel\"],false,[\"if\",\"shared/ui/button\",\"t\",\"svg-jar\",\"html-safe\",\"perfect-scroll\",\"input\",\"autofocus\",\"on\",\"shared/media/filter/filter-media-usage\",\"shared/media/filter/filter-profile\",\"shared/media/filter/filter-media-type\",\"shared/media/filter/filter-date-range\",\"ember-tooltip\",\"each\",\"-track-array\",\"fn\",\"media/manage-labels\"]]",
    "moduleName": "media/components/media/asset-filter.hbs",
    "isStrictMode": false
  });
  let AssetFilterComponent = _exports.default = (_dec = (0, _computed.sort)('groupLabels', 'labelSorting'), _dec2 = (0, _computed.sort)('nonSystemLabels', 'labelSorting'), _dec3 = (0, _computed.sort)('systemLabels', 'labelSorting'), (_class = class AssetFilterComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "labelSearchString", _descriptor, this);
      _initializerDefineProperty(this, "showAllLabels", _descriptor2, this);
      _initializerDefineProperty(this, "showManageLabelsModal", _descriptor3, this);
      _initializerDefineProperty(this, "sortedGroupLabels", _descriptor4, this);
      _initializerDefineProperty(this, "sortedNonSystemLabels", _descriptor5, this);
      _initializerDefineProperty(this, "sortedSystemLabels", _descriptor6, this);
      _defineProperty(this, "labelSorting", ['taggedCount:desc']);
      this.labelSearchString = undefined;
      this.showAllLabels = false;
      this.showManageLabelsModal = false;
    }
    get groupLabels() {
      return this.args.group?.labels;
    }
    get isSearchingLabels() {
      return !(0, _utils.isEmpty)(this.labelSearchString);
    }
    get nonSystemLabels() {
      return this.groupLabels?.filter(label => !label.isSystemLabel);
    }
    get nonSystemLabelCount() {
      return this.nonSystemLabels?.length;
    }
    get showLoadMoreLabels() {
      if (!this.nonSystemLabelCount) {
        return false;
      }
      return !this.isSearchingLabels && this.nonSystemLabelCount > _constants.MEDIA_LABEL_DEFAULT_DISPLAY_LIMIT;
    }
    get showSocialProfileFilter() {
      return this.args.usedUnused === 'used' || this.args.usedUnused === 'unused';
    }
    get sortedToggledSystemLabels() {
      const labels = this.showAllLabels ? this.sortedSystemLabels : this.sortedSystemLabels.slice(0, _constants.MEDIA_LABEL_DEFAULT_DISPLAY_LIMIT);
      return labels.map(label => {
        const labelId = label.id;
        return {
          id: labelId,
          selected: this.args.queryLabelIds.includes(parseInt(labelId)),
          canonicalTagName: label.canonicalTagName,
          taggedCount: label.taggedCount,
          qaClassName: label.canonicalTagName.split(' ')[0].toLowerCase()
        };
      });
    }
    get sortedToggledUserLabels() {
      let labels = null;
      if (!(0, _utils.isEmpty)(this.labelSearchString)) {
        labels = (0, _filterByFields.default)(this.sortedNonSystemLabels, ['tagName'], this.labelSearchString);
      } else if (this.showAllLabels) {
        labels = this.sortedNonSystemLabels;
      } else {
        labels = this.sortedNonSystemLabels.slice(0, _constants.MEDIA_LABEL_DEFAULT_DISPLAY_LIMIT);
      }
      return labels.map(label => {
        const labelId = label.id;
        return {
          id: labelId,
          selected: this.args.queryLabelIds.includes(parseInt(labelId)),
          canonicalTagName: label.canonicalTagName,
          taggedCount: label.taggedCount
        };
      });
    }
    get systemLabels() {
      return this.groupLabels?.filter(label => label.isSystemLabel);
    }
    clearLabelSearch() {
      this.labelSearchString = undefined;
    }
    closeManageLabelsModal() {
      this.showManageLabelsModal = false;
    }
    openManageLabelsModal() {
      this.showManageLabelsModal = true;
    }
    toggleAllLabels() {
      this.showAllLabels = !this.showAllLabels;
    }
    toggleLabel(labelId) {
      if (this.args.queryLabelIds.includes(parseInt(labelId))) {
        this.args.removeQueryLabel(labelId);
      } else {
        this.args.addQueryLabel(labelId);
      }
    }
    toggleSocialProfile(socialProfileSelected) {
      if (!socialProfileSelected?.id) {
        this.args.clearQuerySocialProfile();
      } else if (this.args.querySocialProfileIds.includes(parseInt(socialProfileSelected.id))) {
        this.args.removeQuerySocialProfile(socialProfileSelected);
      } else {
        this.args.addQuerySocialProfile(socialProfileSelected);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "labelSearchString", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showAllLabels", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "showManageLabelsModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "sortedGroupLabels", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sortedNonSystemLabels", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "sortedSystemLabels", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "clearLabelSearch", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearLabelSearch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeManageLabelsModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeManageLabelsModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openManageLabelsModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openManageLabelsModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleAllLabels", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleAllLabels"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleLabel", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSocialProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSocialProfile"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AssetFilterComponent);
});